import { Grid } from '@mui/material';
import { useTheme } from '@mui/styles';
import { ArrowBack as BackArrowIcon } from '@tassat/icon';
import { WalletTotalBalanceTile } from '@tassat/text';
import React, { useMemo } from 'react';
import { LinkProps, Link as RouterLink } from 'react-router-dom';

import TransactionHistory from 'Containers/client/pages/transactionHistory';
import Header from 'Containers/header';
import { getAccountBalancesTileData } from 'Lib/accountBalancesHelper';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';
import { useAppDispatch, useAppSelector } from 'Reducers/store/hooks';
import { setSelectedAccount } from 'Reducers/ui';
import { getAccountPositionsStats } from 'Selectors/accountPositions';
import { getSelectedAccountId } from 'Selectors/common';
import { getClientFirm } from 'Selectors/firms';

import type { FirmHistoryProps } from '.';

const Link = (RouterLink as unknown) as React.ComponentClass<LinkProps>;

export function FirmHistory (props: FirmHistoryProps) {
    const { classes } = props;

    const selectedAccountId = useAppSelector(getSelectedAccountId);
    const firm = useAppSelector(getClientFirm);
    const accountPositionBalance = useAppSelector((state) => getAccountPositionsStats(state, false, firm.IsCollateral));

    const accountPositionStats = useMemo(() => {
        if (accountPositionBalance && accountPositionBalance[0] &&
            Object.keys(accountPositionBalance[0].ccy).length === 0 &&
            Object.keys(accountPositionBalance[0].security).length === 0) return [];

        return getAccountBalancesTileData((accountPositionBalance || []), firm.IsCollateral);
    }, [ accountPositionBalance, firm ]);
    const theme = useTheme<ApplicationMuiTheme>();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        if (selectedAccountId) {
            dispatch(setSelectedAccount(''));
        }
    }, [selectedAccountId]);

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            spacing={0}
            wrap='nowrap'
        >
            <Header />
            <Grid
                className={classes.topContent}
                container
                direction='row'
                item
                spacing={0}
                xs={12}
            >
                <Grid
                    className={classes.backArrow}
                    item
                >
                    <Grid
                        container
                        direction='row'
                        item
                        justifyContent='flex-start'
                        sm={12}
                        spacing={0}
                    >
                        <Link
                            className={classes.anchorText}
                            to='/accounts'
                        >
                            <BackArrowIcon
                                className={classes.itemTitle}
                                iconColor={theme?.app?.applicationColors.fontColor ||
                                    '#202020'}
                            />
                        </Link>
                    </Grid>
                </Grid>
                <Grid
                    container
                    direction='column'
                    item
                    justifyContent='flex-start'
                    spacing={0}
                    wrap='nowrap'
                    xs={7}
                >
                    {accountPositionStats && <WalletTotalBalanceTile stats={accountPositionStats} />}
                </Grid>
            </Grid>
            <Grid
                className={classes.historyContainer}
                container
                direction='column'
                spacing={0}
                wrap='nowrap'
            >
                <TransactionHistory
                    firm={firm}
                />
            </Grid>
        </Grid>
    );
}